'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import DistributionManagement from './components/DistributionManagement';

export default function DistributionManagementPage() {
  return (
    <AppLayout portalRole="finance">
      <DistributionManagement />
    </AppLayout>
  );
}
